import { useTranslation } from 'react-i18next'
import { ReactNode } from 'react'

// local imports
import { IOnCampusHealthServiceFirmStatistics } from 'types/DashboardType'
import { saveAsExcelFile } from 'utils/Miscellaneous'
import ExportBtn from './ExportBtn'

interface CompProps {
  children: ReactNode
  excelData: any
}

export default function HealthServiceDist({ excelData, children }: CompProps) {
  const { t } = useTranslation()

  const handleExport = () => {
    import('xlsx').then((xlsx) => {
      let heading = [
        [
          t('most-used-words.firm'),
          t('dashboard.on-campus-tabs.came'),
          t('dashboard.on-campus-tabs.not_came'),
          t('dashboard.on-campus-tabs.cancelled'),
          t('dashboard.num-of-all-notification'),
        ],
      ]

      const arr = excelData?.map((res: any) => {
        const { FirmName, CameCount, NotCameCount, CancelCount, TotalCount } = res
        return { FirmName, CameCount, NotCameCount, CancelCount, TotalCount }
      })

      const totalRow = arr.reduce(
        (acc: IOnCampusHealthServiceFirmStatistics, curr: IOnCampusHealthServiceFirmStatistics) => {
          acc.cameCount += curr.cameCount || 0
          acc.notCameCount += curr.notCameCount || 0
          acc.cancelCount += curr.cancelCount || 0
          acc.totalCount += curr.totalCount || 0
          return acc
        },
        {
          FirmName: '',
          CameCount: 0,
          NotCameCount: 0,
          CancelCount: 0,
          TotalCount: 0,
        }
      )

      let heading2 = {
        FirmName: '',
        CameCount: t('dashboard.excel.total-coming'),
        NotCameCount: t('dashboard.excel.total-not-coming'),
        CancelCount: t('dashboard.excel.total-cancel'),
        TotalCount: t('dashboard.on-campus-tabs.all-detail-msg'),
      }

      arr.push(...[{}, heading2, totalRow])

      /* header */
      const ws = xlsx.utils.book_new()
      xlsx.utils.sheet_add_aoa(ws, heading)
      const worksheet = xlsx.utils.sheet_add_json(ws, arr!, { origin: 'A2', skipHeader: true })
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] }
      const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' })
      saveAsExcelFile(excelBuffer, t('dashboard.on-campus-tabs.health-service-res'))
    })
  }

  return (
    <>
      {!!excelData && excelData?.length ? <ExportBtn handleExport={handleExport} /> : null}
      {children}
    </>
  )
}
